import { forwardRef, memo, SVGProps } from 'react';
import { ReactComponent as Spin } from '@assets/images/loader-circle.svg';

const Spinner = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => {
  const { className, ...otherProps } = props;
  return <Spin {...otherProps} ref={ref} className={`spinner-wrapper ${className}`} />;
});

export default memo(Spinner);
